import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import DashboardSkeleton from "../../common/DashboardSkeleton";
import { useSelector } from "react-redux";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";
import formatDateAndTime from "../../common/formatDateAndTime";

const Tinkeringandpainting = ({ setSavedAmount, cityFilter }) => {
  const cities = useSelector((state) => state?.cities?.citiesData);
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  let token = localStorage.getItem("token");
  const [tinkeringandPaintingData, setTinkeringandPaintingData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [statusFilter, setStatusFilter] = useState("All");
  const [searchText, setSearchText] = useState("");
  const rowsPerPage = 10;
  const workorderStatusValue = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.workorderStatus;

  const handleCopy = async (text, label) => {
    if (!text) return;
    try {
      await navigator.clipboard.writeText(String(text));
      toast.success(`${label} copied to clipboard`);
    } catch (err) {
      toast.error(`Failed to copy ${label.toLowerCase()}`);
    }
  };

  const totalPages = Math.max(
    1,
    Math.ceil(
      tinkeringandPaintingData?.serviceList?.rows?.length / rowsPerPage,
    ),
  );
  const startIndex = (currentPage - 1) * rowsPerPage;
  const filteredRows = (
    tinkeringandPaintingData?.serviceList?.rows || []
  ).filter((data) => {
    const searchValue = searchText.trim().toLowerCase();

    if (!searchValue) {
      return true;
    }

    return [data?.serviceCode, data?.licensePlate, cities[data?.cityId]]
      .filter(Boolean)
      .some((value) => String(value).toLowerCase().includes(searchValue));
  });
  const paginatedVehicles = filteredRows.slice(
    startIndex,
    startIndex + rowsPerPage,
  );

  const getTinkeringandPaintingDataAPI = async () => {
    if (!token) {
      return toast.error("Session Expired Close all the tab and signin again");
    }
    // const formattedStartDate = formatDateForApi(
    //   selectionRange?.startDate,
    //   "start",
    // );
    // const formattedEndDate = formatDateForApi(selectionRange?.endDate, "end");
    setLoading(true);
    let query = "";
    if (cityFilter && cityFilter !== "All Cities") {
      query += `&cityId=${cityFilter}`;
    }
    // ?startDate=${formattedStartDate}&endDate=${formattedEndDate}${query}
    try {
      const response = await fetch(
        `${apiUrl}/api/dashboardreports/tinkering-painting?${query}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setLoading(false);
        setTinkeringandPaintingData(data?.dataValues);
        setCurrentPage(1);
        setSavedAmount(data?.dataValues?.metricsSummary?.savedAmount);
      } else {
        setLoading(false);
        toast.error(data?.msg);
      }
      return data;
    } catch (error) {
      return;
      setLoading(false);
      console.error("Error fetching Hub Names:", error);
    }
  };

  useEffect(() => {
    getTinkeringandPaintingDataAPI();
  }, [cityFilter]);

  const tinkeringandPaintingOverviewData = {
    counts: [
      {
        title: "Total Amt",
        value: "₹ " + tinkeringandPaintingData?.metricsSummary?.totalAmount || 0,
        image: null,
        // outof: "Total Repair Cost",
        class: "text-black",
        bg: "bg-blue-400",
      },
      {
        title: "Customer Paid Amt",
        value:
          "₹ " + tinkeringandPaintingData?.metricsSummary?.customerPaidAmount ||
          0,
        image: null,
        // outof: "Total Repair Cost",
        class: "text-black",
        bg: "bg-green-400",
      },
      {
        title: "Company Paid Amt",
        value:
          "₹ " + tinkeringandPaintingData?.metricsSummary?.companyPaidAmount ||
          0,
        image: null,
        // outof: "Total Repair Cost",
        class: "text-black",
        bg: "bg-red-400",
      },
      {
        title: "Total Dispersed Amount",
        value:
          "₹ " + tinkeringandPaintingData?.metricsSummary?.totalDispersedAmount ||
          0,
        image: null,
        // outof: "Total Repair Cost",
        class: "text-black",
        bg: "bg-yellow-400",
      },
    ],
    countstwo: [
      {
        title: "Count",
        value: tinkeringandPaintingData?.metricsSummary?.tnpJobCount || 0,
        image: null,
        outof: "Total T&P Jobs",
        class: "text-black",
        bg: "bg-red-400",
      },
      {
        title: "Damage Charges Collected",
        value: "₹ " + tinkeringandPaintingData?.metricsSummary?.totalDamageChargesCollected || 0,
        image: null,
        outof: "amount",
        class: "text-black",
        bg: "bg-green-400",
      },
      {
        title: "Downtime Charges Collected",
        value: "₹ " + tinkeringandPaintingData?.metricsSummary?.totalDowntimeChargesCollected || 0,
        image: null,
        outof: "amount",
        class: "text-black",
        bg: "bg-yellow-400",
      },
      {
        title: "Payment Completed",
        value:
          "₹ " + tinkeringandPaintingData?.metricsSummary?.totalAmountPaidByCompany ||
          0,
        image: null,
        outof: "Paid Invoices",
        class: "text-black",
        bg: "bg-blue-400",
      },
      {
        title: "Payment Pending",
        value:
          "₹ " + tinkeringandPaintingData?.metricsSummary?.totalPaymentPendingForCompany || 0,
        image: null,
        outof: "Unpaid Invoices",
        class: "text-black",
        bg: "bg-orange-400",
      },
    ],
  };

  const handleDownload = (url) => {
    if (url) {
      window.open(url, "_blank");
    }
  };

  return (
    <>
      {loading ? (
        <>
          <DashboardSkeleton />
        </>
      ) : (
        <>
          <div className="w-full p-2 inline-flex flex-col justify-start items-start gap-6 overflow-hidden">
            <div className="self-stretch h-32 inline-flex justify-start items-start gap-5">
              {tinkeringandPaintingOverviewData &&
                tinkeringandPaintingOverviewData.counts.map((data, index) => (
                  <div className="flex-1 h-32 p-5 relative bg-white rounded-bl-xl rounded-br-xl shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)] outline outline-1 outline-offset-[-1px] outline-slate-200 inline-flex flex-col justify-start items-start gap-4">
                    <div
                      className={`w-[95%] h-2 left-[10px] top-0 absolute rounded-bl-lg rounded-br-lg ${data?.bg}`}
                    />
                    <div className="self-stretch inline-flex justify-between items-center">
                      <div className="justify-start text-slate-500 text-xs font-semibold font-['Inter'] uppercase">
                        {data?.title}
                      </div>
                    </div>
                    <div className="self-stretch flex flex-col justify-start items-start gap-1">
                      <div className="justify-start text-slate-900 text-3xl font-bold font-['Inter']">
                        {data?.value}
                      </div>
                      {/* <div className="self-stretch justify-start text-slate-400 text-xs font-normal font-['Inter'] leading-4">
                Total claimed
              </div> */}
                    </div>
                  </div>
                ))}
            </div>
            <div className="self-stretch inline-flex justify-start items-start gap-2.5 overflow-hidden">
              {tinkeringandPaintingOverviewData &&
                tinkeringandPaintingOverviewData?.countstwo.map(
                  (data, index) => (
                    <div className="flex-1 p-4 relative bg-white rounded-2xl border-l border-r border-t-[1.60px] border-b border-slate-200 inline-flex flex-col justify-start items-start gap-2 overflow-hidden">
                      <div
                        className={`w-full h-1 left-0 top-0 absolute ${data?.bg}`}
                      />
                      <div className="self-stretch justify-start text-slate-500 text-[10px] font-semibold font-['Inter'] tracking-wide">
                        {data?.title}
                      </div>
                      <div className="self-stretch justify-start text-slate-900 text-xl font-bold font-['Inter']">
                        {data?.value}
                      </div>
                      <div className="self-stretch justify-start text-slate-400 text-xs font-normal font-['Inter']">
                        {data?.outof}
                      </div>
                    </div>
                  ),
                )}
            </div>
            <div className="w-full bg-white rounded-xl border border-slate-200 overflow-hidden">
              <div className="flex items-center justify-between p-4 border-b border-slate-200 gap-3 flex-wrap">
                <div className="flex items-center gap-2">
                  <h2 className="text-sm font-bold uppercase tracking-tight text-slate-900">
                    Tinkering & Painting - All Vehicles
                  </h2>
                  <span className="text-lg font-semibold">→</span>
                </div>

                <div className="flex items-center gap-3 flex-wrap">
                  <input
                    type="text"
                    value={searchText}
                    onChange={(event) => setSearchText(event.target.value)}
                    placeholder="Search vehicle no or code"
                    className="px-3 py-2 border border-slate-300 rounded-md text-sm outline-none focus:border-blue-500"
                  />
                  <div className="px-4 py-2 border border-slate-200 rounded-lg text-sm font-semibold">
                    {filteredRows.length}
                  </div>

                  <div className="p-1 bg-[#f1f5f9] rounded-lg inline-flex items-center gap-0.5">
                    <div
                      title="Download Full Report"
                      className="cursor-pointer"
                      onClick={() => {
                        handleDownload(tinkeringandPaintingData?.reportUrl);
                      }}
                    >
                      <DownloadForOfflineIcon />
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-full overflow-x-auto">
                <table className="w-full text-left border-collapse">
                  <thead>
                    <tr className="border-t border-b border-slate-200/80 bg-white">
                      <th className="px-6 py-3.5 text-[#94a3b8] text-[10.5px] font-semibold tracking-wider uppercase whitespace-nowrap">
                        CODE
                      </th>

                      <th className="px-6 py-3.5 text-[#94a3b8] text-[10.5px] font-semibold tracking-wider uppercase whitespace-nowrap">
                        REGISTRATION
                      </th>

                      <th className="px-6 py-3.5 text-[#94a3b8] text-[10.5px] font-semibold tracking-wider uppercase whitespace-nowrap">
                        CITY
                      </th>

                      <th className="px-6 py-3.5 text-[#94a3b8] text-[10.5px] font-semibold tracking-wider uppercase whitespace-nowrap">
                        CREATION DATE
                      </th>

                      <th className="px-6 py-3.5 text-[#94a3b8] text-[10.5px] font-semibold tracking-wider uppercase whitespace-nowrap">
                        BLOCK START DATE
                      </th>

                      <th className="px-6 py-3.5 text-[#94a3b8] text-[10.5px] font-semibold tracking-wider uppercase whitespace-nowrap">
                        BLOCK END DATE
                      </th>

                      <th className="px-6 py-3.5 text-[#94a3b8] text-[10.5px] font-semibold tracking-wider uppercase whitespace-nowrap">
                        SERVICE STATUS
                      </th>

                      <th className="px-6 py-3.5 text-[#94a3b8] text-[10.5px] font-semibold tracking-wider uppercase whitespace-nowrap">
                        PAYMENT STATUS
                      </th>
                      <th className="px-6 py-3.5 text-[#94a3b8] text-[10.5px] font-semibold tracking-wider uppercase whitespace-nowrap">
                        OUTSTANDING BALANCE
                      </th>

                      <th className="px-6 py-3.5 text-[#94a3b8] text-[10.5px] font-semibold tracking-wider uppercase whitespace-nowrap">
                        START ODOMETER READING
                      </th>

                      <th className="px-6 py-3.5 text-[#94a3b8] text-[10.5px] font-semibold tracking-wider uppercase whitespace-nowrap">
                        END ODOMETER READING
                      </th>

                      <th className="px-6 py-3.5 text-[#94a3b8] text-[10.5px] font-semibold tracking-wider uppercase whitespace-nowrap text-right">
                        CUSTOMER PAID
                      </th>

                      <th className="px-6 py-3.5 text-[#94a3b8] text-[10.5px] font-semibold tracking-wider uppercase whitespace-nowrap text-right">
                        COST TO COMPANY
                      </th>
                      <th className="px-6 py-3.5 text-[#94a3b8] text-[10.5px] font-semibold tracking-wider uppercase whitespace-nowrap text-right">
                        BILLING AMOUNT
                      </th>
                    </tr>
                  </thead>

                  <tbody className="divide-y divide-slate-100">
                    {filteredRows.length === 0 ? (
                      <tr>
                        <td
                          colSpan={6}
                          className="px-6 py-12 text-center text-xs text-slate-400"
                        >
                          No Data Found
                        </td>
                      </tr>
                    ) : (
                      paginatedVehicles.map((data, index) => (
                        <tr
                          key={`${data?.serviceCode || index}-${index}`}
                          className="hover:bg-slate-50/50 transition-colors"
                        >
                          {/* CODE */}
                          <td className="px-6 py-4 text-[12px] font-normal whitespace-nowrap">
                            <div className="inline-flex items-center gap-1.5">
                              <span>{data?.serviceCode || "-"}</span>

                              {data?.serviceCode && (
                                <button
                                  type="button"
                                  onClick={() =>
                                    handleCopy(data?.serviceCode, "Code")
                                  }
                                  title="Copy Code"
                                  className="p-1 text-slate-400 hover:text-blue-600 hover:bg-blue-50 rounded transition-colors"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="13"
                                    height="13"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  >
                                    <rect
                                      width="14"
                                      height="14"
                                      x="8"
                                      y="8"
                                      rx="2"
                                    />
                                    <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" />
                                  </svg>
                                </button>
                              )}
                            </div>
                          </td>

                          {/* REGISTRATION */}
                          <td className="px-6 py-4 text-[12px] font-bold text-slate-900 whitespace-nowrap">
                            <div className="inline-flex items-center gap-1.5">
                              <span>{data?.licensePlate || "-"}</span>

                              {data?.licensePlate && (
                                <button
                                  type="button"
                                  onClick={() =>
                                    handleCopy(
                                      data?.licensePlate,
                                      "Registration",
                                    )
                                  }
                                  title="Copy Registration"
                                  className="p-1 text-slate-400 hover:text-blue-600 hover:bg-blue-50 rounded transition-colors"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="13"
                                    height="13"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  >
                                    <rect
                                      width="14"
                                      height="14"
                                      x="8"
                                      y="8"
                                      rx="2"
                                    />
                                    <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" />
                                  </svg>
                                </button>
                              )}
                            </div>
                          </td>

                          {/* CITY */}
                          <td className="px-6 py-4 text-[12px] font-normal text-slate-900 whitespace-nowrap">
                            {cities[data?.cityId] || "-"}
                          </td>

                          {/* DATE */}
                          <td className="px-6 py-4 text-[12px] font-normal text-slate-900 whitespace-nowrap">
                            {formatDateAndTime(data?.createdAt) || "-"}
                          </td>

                          <td className="px-6 py-4 text-[12px] font-normal text-slate-900 whitespace-nowrap">
                            {formatDateAndTime(
                              data?.blockedDetails?.startDate,
                            ) || "-"}
                          </td>

                          <td className="px-6 py-4 text-[12px] font-normal text-slate-900 whitespace-nowrap">
                            {formatDateAndTime(data?.blockedDetails?.endDate) ||
                              "-"}
                          </td>

                          <td className="px-6 py-4 text-[12px] font-normal whitespace-nowrap text-slate-900">
                            {workorderStatusValue[data?.serviceStatus] || "-"}
                          </td>

                          <td className="px-6 py-4 text-[12px] font-normal whitespace-nowrap">
                            {data?.isPaymentPending === false ? (
                              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-green-50 border border-green-200 text-green-600 text-xs font-semibold whitespace-nowrap">
                                <span className="flex items-center justify-center w-4 h-4 rounded-full bg-green-500 text-white text-[10px]">
                                  ✓
                                </span>
                                Completed
                              </span>
                            ) : (
                              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-red-50 border border-red-200 text-red-600 text-xs font-semibold whitespace-nowrap">
                                <span className="w-1.5 h-1.5 rounded-full bg-red-500" />
                                Pending
                              </span>
                            )}
                          </td>
                          <td className="px-6 py-4 text-[12px] font-normal whitespace-nowrap text-slate-900">
                            <span className="text-[11px] font-medium">₹</span>
                            {data?.outstandingBalance || " 0"}
                          </td>

                          <td className="px-6 py-4 text-[12px] font-normal whitespace-nowrap text-slate-900">
                            {" "}
                            <span className="inline-flex items-center px-2.5 py-1 rounded-md bg-blue-50 border border-blue-200">
                              {" "}
                              {data?.odometerReading != null
                                ? `${Number(data.odometerReading).toLocaleString()} km`
                                : "-"}{" "}
                            </span>{" "}
                          </td>{" "}
                          <td className="px-6 py-4 text-[12px] font-normal whitespace-nowrap text-slate-900">
                            {" "}
                            <span className="inline-flex items-center px-2.5 py-1 rounded-md bg-blue-50 border border-blue-200">
                              {" "}
                              {data?.endingOdometer != null
                                ? `${Number(data.endingOdometer).toLocaleString()} km`
                                : "-"}{" "}
                            </span>{" "}
                          </td>

                          <td className="px-6 py-4 whitespace-nowrap text-right">
                            <div className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-green-50 border border-green-100">
                              <span className="text-[11px] font-medium text-green-600">
                                ₹
                              </span>

                              <span className="text-[12px] font-semibold text-green-700">
                                {data?.amountPaidByCustomers || 0}
                              </span>
                            </div>
                          </td>

                          {/* COST */}
                          <td className="px-6 py-4 whitespace-nowrap text-right">
                            <div className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-blue-50 border border-blue-100">
                              <span className="text-[11px] font-medium text-blue-600">
                                ₹
                              </span>

                              <span className="text-[12px] font-semibold text-blue-700">
                                {data?.billingDetails?.costToCompany || 0}
                              </span>
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-right">
                            <div className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-red-50 border border-red-100">
                              <span className="text-[11px] font-medium text-red-600">
                                ₹
                              </span>

                              <span className="text-[12px] font-semibold text-red-700">
                                {data?.billingDetails?.billingAmount || 0}
                              </span>
                            </div>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
              <div className="flex items-center justify-between px-5 py-4 border-t border-slate-200">
                <div className="text-sm text-slate-500">
                  Showing {startIndex + 1} -{" "}
                  {Math.min(startIndex + rowsPerPage, filteredRows.length)} of{" "}
                  {filteredRows.length}
                </div>

                <div className="flex items-center gap-2">
                  <button
                    onClick={() =>
                      setCurrentPage((prev) => Math.max(1, prev - 1))
                    }
                    disabled={currentPage === 1}
                    className="px-3 py-1.5 border border-slate-300 rounded-md text-sm disabled:opacity-50"
                  >
                    Prev
                  </button>

                  <span className="text-sm">
                    Page {currentPage} of {totalPages}
                  </span>

                  <button
                    onClick={() =>
                      setCurrentPage((prev) => Math.min(totalPages, prev + 1))
                    }
                    disabled={currentPage === totalPages}
                    className="px-3 py-1.5 border border-slate-300 rounded-md text-sm disabled:opacity-50"
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
            <div className="self-stretch h-16 opacity-0 bg-zinc-300" />
          </div>
        </>
      )}
    </>
  );
};

export default Tinkeringandpainting;
